module.exports = __webpack_public_path__ + "img/fond-troupeau2.c76618cb.jpg";